// e2e opens this database from Node, where app modules (import.meta.env, browser APIs) cannot
// load; its name lives in src/lib/storeNames.ts.
export const PHOTO_QUEUE_STORE = 'pending';
// Rowboat's IndexedDB store opens the database at version 1.
export const PHOTO_QUEUE_VERSION = 1;
